<div class="flex flex-col gap-[0.25rem]">
  <label *ngIf="title" class="input-title" data-qa="selector-autocomplete-deferred-title">
    {{ title }}<span *ngIf="props.required" class="red-10">*</span>
  </label>
  <div
    data-qa="selector-autocomplete-deferred"
    class="control clickable"
    (click)="showPopUpModal = props.openOnClick">
    <span class="control-text" data-qa="selector-autocomplete-deferred-selected-text">
      {{ isSimpleArray ? selectedItem : selectedItem[field] }}
    </span>
    <div class="suffix">
      <app-all-icons [iconNameAndStyling]="'arrow-down.svg'"></app-all-icons>
    </div>
  </div>
  <app-popup-modal *ngIf="showPopUpModal" [innerModal]="isInsideModal" (closeModal)="showPopUpModal=false">
    <div class="picker flex flex-col items-center content-center full-opacity green-scroll">
      <div class="picker-dropdown flex flex-col items-center content-center full-opacity width-unset"
           [ngClass]="outerClass === 'control-container-without-border' ? 'auto-width' : ''" #dropdown>
        <app-input
          class="flex width-100pcnt"
          data-qa="selector-autocomplete-deferred-filter-input"
          (inputChange)="searchInputValue$.next($event)"
          [autofocus]="true">
        </app-input>
        <div class="flex flex-col items-center content-center picker-list">
          <div class="flex flex-col items-center content-center list-block">
            @for (item of filteredData | async; track item) {
              <div #viewportMarker class="w-full">
                @defer (on viewport(viewportMarker); prefetch on idle) {
                  <app-selector-autocomplete-deferred-item
                    [attr.data-qa]="'selector-autocomplete-deferred-list-entry-' + item.header + item.subheader"
                    class="w-full"
                    [item]="item"
                    [selectedItem]="selectedItem"
                    [field]="field"
                    [onLoadAction]="onLoadAction"
                    [isSimpleArray]="isSimpleArray"
                    [fullData]="data"
                    [props]="props"
                    (selected)="setSelected($event)"
                  />
                } @placeholder {
                  <span class="list-entry w-full font-normal black-7">Content loading</span>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </app-popup-modal>
</div>
